export enum PictureMode {
    Empty = 0,
    Upload = 1,
    Gravatar = 2
}